module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fm_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A NOTE ON KÖCHEL NUMBERS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Mozart’s compositions are identified by the numbers assigned to them in the first edition of the chronological thematic list of his works by Ludwig von Köchel, followed by the revised numbers (if any) assigned to them in the sixth edition of Köchel’s catalog (thus, Sonata in A minor, K. 310/300d). This procedure is followed as well for works that formerly were listed in an appendix ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anhang")]), _vm._v(") to the first three editions of Köchel but now appear in the main catalog (thus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Les Petits Riens")]), _vm._v(", K. Anh. 10/299b). K. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deest")]), _vm._v(" designates a work that is not to be found in Köchel.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c95b66d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/anote.vue
// module id = 78
// module chunks = 0